import { css, SerializedStyles } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';

import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const topSignUpContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${MEDIA_MIN_SM} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }
  }
`;

export const signUpForText = css`
  display: flex;
  align-items: center;

  > p {
    margin: 0;
  }
`;

export const descriptionTextContainer = css`
  display: flex;
  width: fit-content;
  flex-direction: column;
  align-items: flex-start;
  color: var(${DesignToken.ContentBasicPrimary});

  > p {
    margin: 0;
  }
`;

export const tooltipText = css`
  margin: 0;
`;

export const startTrialButton = (disabled: boolean): SerializedStyles => css`
  width: fit-content;
  margin-top: var(${SpacingToken.Spacing3});
  margin-bottom: var(${SpacingToken.Spacing6});
  background-color: var(${DesignToken.DecorRed500});
  border: none;

  &:hover {
    ${!disabled && `background-color: var(${DesignToken.DecorRed600});`}
  }
`;

export const goToTheProductContainer = css`
  margin-top: ${SpacingToken.Spacing6};
`;

export const noProductsText = css`
  width: fit-content;
  color: var(${DesignToken.ContentBasicPrimary});
  margin: 0 0 ${SpacingToken.Spacing3} 0;
  text-align: left;
`;
